import { useTranslation } from '../i18n'
import { COLORS } from '../lib/theme'
import { Icon } from './Icon'
import { AnimatedNumber } from './AnimatedNumber'

export interface TopStatsSectionProps {
  teamCount: number
  totalHectares: number
  groundCount: number
  lastTeamId?: string
  lastTeamName?: string
  onContinueWithTeam?: (teamId: string) => void
}

function fmtHa(ha: number): string {
  return ha >= 1000 ? `${(ha / 1000).toFixed(1)}k` : String(Math.round(ha))
}

export function TopStatsSection({
  teamCount,
  totalHectares,
  groundCount,
  lastTeamId,
  lastTeamName,
  onContinueWithTeam,
}: TopStatsSectionProps) {
  const { t } = useTranslation('overview')
  const canContinue = lastTeamId !== undefined && lastTeamName !== undefined && onContinueWithTeam !== undefined

  return (
    <div className="wh-grid-2col-eq" style={{ marginBottom: 16, alignItems: 'stretch' }}>
      <div className="wh-card" style={{ padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0, background: COLORS.primaryContainer, color: COLORS.primary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="group" size={18} />
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: COLORS.outline, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('topStats.teams')}</span>
        </div>
        <div style={{ fontSize: 36, fontWeight: 800, color: COLORS.onSurface, lineHeight: 1 }}>
          <AnimatedNumber value={teamCount} />
        </div>
        {canContinue && (
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px solid ${COLORS.outlineVariant}` }}>
            <div style={{ fontSize: 11, color: COLORS.outline, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>{t('topStats.continueWith')}</div>
            <button
              type="button"
              onClick={() => onContinueWithTeam(lastTeamId)}
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 12, fontWeight: 700, color: COLORS.primary, display: 'flex', alignItems: 'center', gap: 4 }}
            >
              {lastTeamName} <Icon name="arrow_forward" size={14} />
            </button>
          </div>
        )}
      </div>

      <div className="wh-card" style={{ padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0, background: COLORS.primaryContainer, color: COLORS.primary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="leaf" size={18} />
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: COLORS.outline, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('topStats.totalArea')}</span>
        </div>
        <div style={{ fontSize: 36, fontWeight: 800, color: COLORS.onSurface, lineHeight: 1 }}>
          <AnimatedNumber value={totalHectares} format={fmtHa} /> <span style={{ fontSize: 18, fontWeight: 600 }}>ha</span>
        </div>
        <div style={{ fontSize: 12, color: COLORS.outline, marginTop: 4 }}>
          {t('topStats.acrossGrounds', { count: groundCount })}
        </div>
      </div>
    </div>
  )
}
